import { siteConfig } from '@/config/site.config';

// Brand, navigation, and global strings — now sourced from the single site
// config (`src/config/site.config.ts`). This wrapper keeps the existing
// `siteContent` shape so components (Navbar, Footer, …) don't need to change.
export const siteContent = {
    brand: {
        name: siteConfig.brand.name,
        words: siteConfig.brand.words,
        logoAlt: siteConfig.brand.logoAlt,
    },
    location: siteConfig.contact.location,
    rights: siteConfig.contact.rights,
    // Filter and sort navigation links to match the enabled home-page sections.
    // This ensures a buyer only needs to edit `siteConfig.sections` to update both
    // the page content and the navigation menu.
    navLinks: siteConfig.navLinks
        .filter((link) => {
            const sectionKey = link.id === 'home' ? 'hero' : link.id;
            return siteConfig.sections.includes(sectionKey as any);
        })
        .sort((a, b) => {
            const keyA = a.id === 'home' ? 'hero' : a.id;
            const keyB = b.id === 'home' ? 'hero' : b.id;
            return (
                siteConfig.sections.indexOf(keyA as any) -
                siteConfig.sections.indexOf(keyB as any)
            );
        }),
};
